export const META_URL_SITE =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://escape-room-securITy.onrender.com"
